import { makeFilterParams } from '../utils/helpers/helpers';
import httpClient from './httpClient';

const apiCall = async (method, endpoint, params = false, data = false) => {
  const endpointURL = `${endpoint.startsWith('/') ? '' : '/'}${endpoint}${endpoint.endsWith('/') ? '' : '/'}`;
  let endpointConfig = {};
  if (params) endpointConfig = makeFilterParams(params);
  if (data instanceof FormData) {
    endpointConfig['headers'] = {
      'Content-Type': `multipart/form-data;`,
    };
  }
  if (method === 'get')
    return await httpClient.get(endpointURL, endpointConfig);
  else if (method === 'post')
    return await httpClient.post(endpointURL, data, endpointConfig);
  else if (method === 'put')
    return await httpClient.put(endpointURL, data, endpointConfig);
  else if (method === 'patch')
    return await httpClient.patch(endpointURL, data, endpointConfig);
  else if (method === 'delete')
    return await httpClient.delete(endpointURL, endpointConfig);
};

const getAPICall = async (endpoint, params = false) =>
  await apiCall('get', endpoint, params, false);

const ajaxTableCall = async (
  endpoint,
  query = {},
  search = false,
  sortBy = false,
  page = 1,
  pageSize = 10,
  exportCSV = false,
) => {
  const endpointURL = `${endpoint.startsWith('/') ? '' : '/'}${endpoint}${endpoint.endsWith('/') ? '' : '/'}`;
  const endpointConfig = makeFilterParams(
    query,
    page,
    pageSize,
    search,
    sortBy,
    exportCSV,
  );
  return await httpClient.get(
    exportCSV ? `${endpointURL}export/` : endpointURL,
    endpointConfig,
  );
};

export { getAPICall, ajaxTableCall };

export default apiCall;
